/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import(/* webpackChunkName: 'index', webpackPrefetch: true */'@/pages/index/index.vue')
const Download = () => import(/* webpackChunkName: 'download', webpackPrefetch: true */'@/pages/download/index.vue')
const Login = () => import(/* webpackChunkName: 'login', webpackPrefetch: true */'@/pages/login/index.vue')
const Detail = () => import(/* webpackChunkName: 'detail', webpackPrefetch: true */'@/pages/detail/index.vue')
const UVA = () => import(/* webpackChunkName: 'uva', webpackPrefetch: true */'@/pages/UVA/index.vue')

Vue.use(Router)


//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    { 
      path: '/',
      redirect: '/work'
    },
    { 
      path: '/work',
      name: 'index',
      component: Index,
      meta: {
        title: '首页 - 科技元宇宙'
      }
    },
    { 
      path: '/work/download',
      name: 'download',
      component: Download,
      meta: {
        title: '下载 - 科技元宇宙'
      }
    },
    { 
      path: '/work/detail',
      name: 'detail',
      component: Detail,
      meta: {
        title: '详情 - 科技元宇宙'
      }
    },
    { 
      path: '/work/uva',
      name: 'uva',
      component: UVA,
      meta: {
        title: '无人机 - 科技元宇宙'
      }
    },
    { 
      path: '/work/login',
      name: 'login',
      component: Login,
      meta: {
        title: '注册/登录 - 科技元宇宙'
      }
    },
  ]
})
